import { FccDoorActuationError } from '@backoffice-frontend/graphql/subscription'
import { useTranslation } from 'react-i18next'

export const useDoorActuationErrorMessages = () => {
  const { t } = useTranslation()

  return (key: FccDoorActuationError) => {
    if (!key) return ''

    const map: Partial<Record<FccDoorActuationError, string>> = {
      [FccDoorActuationError.TtlExceeded]: t(
        'adFleetMap_toast_doorErrorDidNotReactInTime_label',
      ),
      [FccDoorActuationError.DoorStateMismatch]: t(
        'adFleetMap_toast_doorErrorNotExpectedState_label',
      ),
      [FccDoorActuationError.SlidingDoorDeactivated]: t(
        'adFleetMap_toast_doorErrorDeactivated_label',
      ),
      [FccDoorActuationError.VehicleMoving]: t(
        'adFleetMap_toast_doorErrorVehicleIsMoving_label',
      ),
      [FccDoorActuationError.VehicleNotParked]: t(
        'adFleetMap_toast_doorErrorVehicleIsNotParked_label',
      ),
      [FccDoorActuationError.UnknownError]: t(
        'adFleetMap_toast_doorErrorUnknownError_label',
      ),
    }
    return map[key] ?? key
  }
}
